export enum ProfilingStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum ProfilingRequestSource {
  PortalIntegration = 'PortalIntegration',
  OnboardingRetail = 'Onboarding Retail',
  ClickAndGoPortal = 'Click&Go Portal',
  ClickAndGo = 'Click&Go',
  Onboarding = 'Onboarding',
  OnboardingRetailOnboarding = 'Onboarding RetailOnboarding',
  OnboardingContract = 'Onboarding Contract',
  OnboardingBPRegistration = 'Onboarding BPRegistration',
  OnboardingSPRRegistration = 'Onboarding SimplePartnerRegistration',
  OnboardingBPReconfirmation = 'Onboarding BPReconfirmation',
  PortalIntegrationApollo = 'PortalIntegration Apollo',
  OnboardingRetailApollo = 'Onboarding Retail Apollo',
  ClickAndGoApollo = 'Click&Go Apollo',
  OnboardingApollo = 'Onboarding Apollo',
  OnboardingRetailOnboardingApollo = 'Onboarding RetailOnboarding Apollo',
  OnboardingContractApollo = 'Onboarding Contract Apollo',
  OnboardingBPRegistrationApollo = 'Onboarding BPRegistration Apollo',
  OnboardingSPRRegistrationApollo = 'Onboarding SimplePartnerRegistration Apollo',
  OnboardingBPReconfirmationApollo = 'Onboarding BPReconfirmation Apollo',
  Dialer = 'Dialer',
  P360 = 'P360',
  HAI = 'HAI',
  Lut = 'Lut',
}
